import { useState } from 'react'
import { FormattedMessage } from 'react-intl'

import Dropdown from 'components/v2/Dropdown'
import List from 'components/v2/List'
import { Button } from 'components/v2/Button'
import { CancelChangeModal } from 'features/Changes/components/CancelChangeModal'
import { isScheduled } from 'resolvers/changes'

export const ChangeActions = ({ change }: TSFixMe): TSFixMe => {
  const [isOpenDropdown, setOpenDropdown] = useState(false)
  const [isOpenCancelChangeModal, setOpenCancelChangeModal] = useState(false)

  const toggleDropdown = (): TSFixMe => {
    setOpenDropdown(!isOpenDropdown)
  }

  const canBeCancelled = isScheduled(change)

  return (
    <>
      <Dropdown.Wrapper noPadding noIndicator right onClickAway={(): TSFixMe => setOpenDropdown(false)}>
        <Button kind="terciary" onClick={toggleDropdown}>
          <FormattedMessage id="dictionary.actions" defaultMessage="Actions" />
        </Button>

        <Dropdown.Content open={isOpenDropdown} noIndicator right>
          <List.Container>
            <List.Item
              action
              onClick={(): TSFixMe => {
                if (canBeCancelled) {
                  setOpenDropdown(false)
                  setOpenCancelChangeModal(true)
                }
              }}
              disabled={!canBeCancelled}
            >
              <FormattedMessage id="dictionary.cancel" defaultMessage="Cancel" />
            </List.Item>
          </List.Container>
        </Dropdown.Content>
      </Dropdown.Wrapper>

      {isOpenCancelChangeModal && (
        <CancelChangeModal change={change} closeModal={(): TSFixMe => setOpenCancelChangeModal(false)} />
      )}
    </>
  )
}
